import styled from 'styled-components';
import { device } from '../../../styles/devices';
import { SIZING, COLORS } from '../../../styles/variables';

export const FilterHeader = styled.div`
  padding: 28px 0px 8px 24px;
`;

export const VehicleTypeContentWrapper = styled.div`
  padding: 24px 24px 25px 24px;
`;
